import React, { useMemo } from 'react'

import { useListViewContext } from 'features/views/ListView/useListViewContext'

import useDeepEqualsMemoValue from 'v2/ui/utils/useDeepEqualsMemoValue'

import { useFiltersCollection } from './hooks/useFiltersCollection'
import { useInlineFiltersAvailableFields } from './hooks/useInlineFiltersAvailableFields'
import { FiltersContext } from './useFiltersContext'
import { getInlineFilterType } from './utils'

export type FiltersContextProviderProps = {}

export const FiltersContextProvider: React.FC<FiltersContextProviderProps> = ({ children }) => {
    const { view, additionalFilters } = useListViewContext()

    const adminFilter = view.options.filters

    const {
        filters: inlineFilters,
        addFilter,
        removeFilter,
        updateFilter,
        setFilters,
        clearFilters,
    } = useFiltersCollection()

    const effectiveFilters = ([] as Filter[])
        .concat(additionalFilters ?? [])
        .concat(adminFilter ?? [])
        .concat(inlineFilters)
    const effectiveFiltersMemo = useDeepEqualsMemoValue(effectiveFilters)

    const inlineFilterType = getInlineFilterType(view.options)

    const availableInlineFilterFields = useInlineFiltersAvailableFields(inlineFilterType)

    const value = useMemo(
        () => ({
            filters: effectiveFiltersMemo,
            inlineFilters,
            addFilter,
            removeFilter,
            updateFilter,
            setFilters,
            clearFilters,
            availableInlineFilterFields,
            inlineFilterType,
        }),
        [
            addFilter,
            inlineFilters,
            clearFilters,
            effectiveFiltersMemo,
            removeFilter,
            setFilters,
            updateFilter,
            availableInlineFilterFields,
            inlineFilterType,
        ]
    )

    return <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>
}
